export type Faq = {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this suitable for coaches who are just starting out?',
    answer:
      'Yes. Tennis 360 gives you the complete professional structure that no coaching certification ever fully provides. New coaches get a full system from day one.',
  },
  {
    question: 'What levels and age groups does this cover?',
    answer:
      'Every level: children from Sub-10 through to advanced, adults and teens at all three levels, plus specialist volumes for senior players and students returning from injury.',
  },
  {
    question: 'Is this a physical book or a digital product?',
    answer:
      'Tennis 360 is a digital product delivered as PDF files, optimised for both mobile screens and A4 printing. Read it on your phone at courtside or print it at home.',
  },
  {
    question: 'How do I receive my purchase?',
    answer:
      'Immediately after payment you receive an email with your download link. Access is instant — you can be using the material within 5 minutes.',
  },
  {
    question: 'What if I am not satisfied?',
    answer:
      'You are fully covered by a 7-day money-back guarantee. Simply send us a message and we will refund you in full. No questions, no forms.',
  },
  {
    question: 'Can I use this for school or academy classes?',
    answer:
      'Absolutely. Every volume includes group adaptations and the Survival Kit bonus is specifically designed for complex group and school environments.',
  },
  {
    question: 'How is this different from free drills I can find online?',
    answer:
      'Free resources give you isolated drills with no context or progression. Tennis 360 is a complete coaching system — every drill connects to the next, every level builds on the previous one, and every session has a clear objective.',
  },
]
